import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EmailConfigPage } from './EmailConfigPage';
import { EmailTemplatePage } from './EmailTemplatePage';
import { EmailTemplateLibraryTab } from './EmailTemplateLibraryTab';
import { EmailQueuePage } from './EmailQueuePage';
import { EmailJobPage } from './EmailJobPage';

const TABS = ['providers', 'transactional', 'email-templates', 'queue', 'job'] as const;
type EmailTab = (typeof TABS)[number];

function isValidTab(t: string | null): t is EmailTab {
  // keep backward compat: old ?tab=templates → transactional
  if (t === 'templates') return true;
  return TABS.includes(t as EmailTab);
}

function resolveTab(raw: string | null): EmailTab {
  if (raw === 'templates') return 'transactional';
  return isValidTab(raw) ? (raw as EmailTab) : 'providers';
}

export function EmailPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = resolveTab(searchParams.get('tab'));

  function handleTabChange(value: string) {
    setSearchParams({ tab: value }, { replace: true });
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold">Email</h1>
        <p className="text-sm text-muted-foreground">Manage email providers, templates, queue, and background jobs.</p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="providers">Providers</TabsTrigger>
          <TabsTrigger value="transactional">Transactional</TabsTrigger>
          <TabsTrigger value="email-templates">Email Templates</TabsTrigger>
          <TabsTrigger value="queue">Queue</TabsTrigger>
          <TabsTrigger value="job">Job</TabsTrigger>
        </TabsList>

        <TabsContent value="providers" className="pt-4">
          <EmailConfigPage />
        </TabsContent>
        <TabsContent value="transactional" className="pt-4">
          <EmailTemplatePage />
        </TabsContent>
        <TabsContent value="email-templates" className="pt-4">
          <EmailTemplateLibraryTab />
        </TabsContent>
        <TabsContent value="queue" className="pt-4">
          <EmailQueuePage />
        </TabsContent>
        <TabsContent value="job" className="pt-4">
          <EmailJobPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
